import logo from '../../../assets/png/logo.png';

export function Logo2() {
  return <img src={logo} alt="Logo" width="141px" height="76px"/>;
}